import { createTheme } from "@mui/material/styles";
import "./fonts/font.css";

const theme = createTheme({
  // direction: "rtl",
  typography: {
    fontFamily: "VazirMatn",
  },
  // cssVariables: {
  //   colorSchemeSelector: "data-toolpad-color-scheme",
  // },
  // colorSchemes: { light: true, dark: true },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 600,
  //     md: 600,
  //     lg: 1200,
  //     xl: 1536,
  //   },
  // },
});

export default theme;
